import Config from '../../config';
import OutputGeometry from './geometry';
import OutputModel from './model';

import { Helpers } from '../../helpers';
import { TextContainer, Miscellaneous } from '../../building_blocks/blocks';

class Output {

    constructor(id, position, textLineVariations, outputs) {
          
        if(!Helpers.isPoint(position))
            throw new Error(`'position' argument must be of type Point`);

        this._model = new OutputModel(id, textLineVariations, outputs);
        this._geometry = new OutputGeometry(position, this.getModel().getTextLines(0));

        this._shouldUpdateGeometry = true;
    }

    draw(canvas) {

        if(this._shouldUpdateGeometry) {

            this.getGeometry().updateGeometry(canvas, 
                                          Config.Style.Text.Font, 
                                          this.getGeometry().getPosition(), 
                                          this.getModel().getTextLines(0));

            this._shouldUpdateGeometry = false;                    
        }


        Miscellaneous.drawLine(canvas, 
                               Config.Style.Links.Color, 
                               this.getGeometry().getInputPosition(), 
                               this.getGeometry().getOutputPosition(0));

        Miscellaneous.drawInputAnchor(canvas, 
                                      Config.Style.Anchors.Color, 
                                      this.getGeometry().getInputPosition());

        Miscellaneous.drawOutputAnchor(canvas, 
                                       Config.Style.Anchors.Color, 
                                       this.getGeometry().getOutputPosition(0));


        for(let i=0; i< this.getModel().getTextLineCount(0); i++) {

            TextContainer.drawTextContainer(canvas, 
                                            Config.Style.ChatItem.Colors.Rosie.Background, 
                                            Config.Style.ChatItem.Colors.Rosie.Foreground,
                                            TextContainer.ContainerType().Round,
                                            Config.Style.Text.Font, 
                                            this.getGeometry().getTextLinePosition(i), 
                                            this.getModel().getTextLine(0, i));
        }
    }

    invalidate() {

        this._shouldUpdateGeometry = true;
    }

    translate(dx, dy) {

        this.getGeometry().translate(dx, dy);
    }

    isAtLocation(x, y) {

        let position = this.getGeometry().getPosition();
        let size = this.getGeometry().getSize();

        return position.x - size.width / 2 < x && x < position.x + size.width / 2 &&
               position.y < y && y < position.y + size.height;
    }

    getInputPositionAtLocation(location, radius) {

        let inputPosition = this.getGeometry().getInputPosition();

        if(inputPosition.distanceTo(location) < radius)
            return inputPosition;
        else
            return null;
    }

    getOutputPositionAtLocation(location, radius) {

        let outputPositions = this.getGeometry().getOutputPositions();

        for(let outputPosition of outputPositions)
            if(outputPosition.distanceTo(location) < radius)
                return outputPosition;

        return null;
    }

    getOutputAtLocation(location, radius) {

        for(let i=0; i<this.getModel().getOutputCount(); i++)
            if(this.getGeometry().getOutputPosition(i).distanceTo(location) < radius)
                return i;

        return null;
    }

    getModel() {

        return this._model;
    }

    getGeometry() {

        return this._geometry;
    }

    exportElement() {

        return {

            id: this.getModel().getId(),
            type: 'output',
            position: this.getGeometry().getPosition(),
            textLineVariations: this.getModel().getTextLineVariations(),
            outputs: this.getModel().getOutputs()
        };
    }

    static create(elementDescriptor) {

        return new Output(elementDescriptor.id, 
                          elementDescriptor.position,
                          elementDescriptor.textLineVariations,
                          elementDescriptor.outputs);
    }
}

export default Output;